import Channel from '../../domain/Channel';

export default (channels: Channel[], parentId: number): Channel[] => {
    return channels.filter((channelChildren: Channel) => channelChildren.parent === parentId && channelChildren.parent !== undefined);
};



// WEBPACK FOOTER //
// ./src/view/channels/getChildrenNodes.ts